import React from 'react';
import { Provider } from 'react-redux';

import ThemeProvider from '@ui-lib/ThemeProvider';
import UnleashProvider from '@web-shared/services/UnleashProvider';

import './App.scss';
import './i18n/yupConfig';

import { Router } from './Router';
import { store } from './redux/store';
import { SplashScreen } from './pages/SplashScreen';

function App() {
  return (
    <UnleashProvider>
      <Provider store={store}>
        <ThemeProvider>
          <SplashScreen>
            <Router />
          </SplashScreen>
        </ThemeProvider>
      </Provider>
    </UnleashProvider>

  );
}

export default App;
